import { connect } from 'react-redux';
import { emitMessage, dismissFirstMessage, clearMessages } from 'src/modules/Modal';
import { pushNotification } from 'src/modules/Notification';
import {
    initializeCode,
    selectRestaurantData,
    selectTableNameAndNumber,
    selectRestaurantSlug
} from 'src/modules/Restaurant';

import { selectFingerprint } from 'src/modules/User';

import {
    selectOrderContext,
    connectOrdersSocket,
    disconnectOrdersSocket,
    connectBillSocket,
    disconnectBillSocket,
    selectNotification,
    selectReinitialize,
    selectSessionError,
    selectIsAnyOrder,
    selectOrderStatus,
    selectShouldShowSessionEndedMessage
} from 'src/modules/Order';

const mapDispatchToProps = {
    emitMessage,
    dismissFirstMessage,
    connectOrdersSocket,
    disconnectOrdersSocket,
    pushNotification,
    connectBillSocket,
    disconnectBillSocket,
    initialize: initializeCode,
    clearMessages
};

const mapStateToProps = (state) => ({
    context: selectOrderContext(state),
    restaurant: selectRestaurantData(state),
    table: selectTableNameAndNumber(state),
    notification: selectNotification(state),
    reinitialize: selectReinitialize(state),
    fingerprint: selectFingerprint(state),
    sessionError: selectSessionError(state),
    slug: selectRestaurantSlug(state),
    isAnyOrder: selectIsAnyOrder(state),
    orderStatus: selectOrderStatus(state),
    shouldShowSessionEndMessage: selectShouldShowSessionEndedMessage(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
